export default __webpack_public_path__ + "static/media/cogwheel 1.a528f428.svg";